<div id="container-recurrence">
	<div class="breadcrumb-area mb-2">
		<h1>Cuentas por cobrar</h1>
		<ol class="breadcrumb">
			<li><i class="bx bx-history"></i>Recurrencia</li>
		</ol>
	</div>
	<div class="card mb-1">
		<div class="card-header recurrence-sticky">
			<h2>Configuración de facturación recurrente</h2>
			<div class="settings">
				<button type="button" class="col-sm btn btn-success" (click)="createRecurrence()" 
					[disabled]="
						!recurrenceObject.wareHouse || 
						!recurrenceObject.startDate || 
						(!recurrenceObject.endDate && recurrenceObject.recurrence != '9' && recurrenceObject.recurrence != '10') || 
						!recurrenceObject.billingDate || 
						!recurrenceObject.recurrence || 
						((recurrenceObject.recurrence != '9' && recurrenceObject.recurrence != '10') && recurrenceObject.clients.length == 0) || 
						listProducts.length == 0 || 
						loading
					">
					<i *ngIf="!loading" class="fa fa-save"></i>
					<span *ngIf="loading" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
					GUARDAR
					</button>
			</div>
		</div>
		<div class="card-body">
			<h3>1. Configuración de facturación</h3>
			<div class="row">
				<div class="col form-group mb-1">
					<label for="warehouse" class="form-label">Bodega</label>
					<span class="clickeable text-info" tooltip="Crea una bodega"><i
							class="fa fa-circle-plus"></i></span>
					<div class="input-group input-group-sm">
						<app-input-autocomplete [allBorderRadius]="false"
							[filterElements]="inputs.warehouse.filterElements" [allBorderRadius]="true"
							[inputs]="inputs.warehouse"
							(getTitle)="$event.filterElement.title = $event.filterElement.name"
							[placeholder]="'Ingresa una bodega'"
							(inputMethod)="writeWarehouse($event.event.target.value)"
							(changeStatus)="selectWarehouse($event.filterElement)">
						</app-input-autocomplete>
					</div>
				</div>
				<div class="col form-group mb-1">
					<label for="name" class="form-label">Nombre</label>
					<input type="text" [(ngModel)]="recurrenceObject.description" placeholder="Ingrese el nombre"
						name="name" id="name" class="form-control">
				</div>
				<div class="col form-group mb-1" *ngIf="recurrenceObject.recurrence == '9' || recurrenceObject.recurrence == '10'">
					<label for="startTime" class="form-label">Hora Inicio</label>
					<input type="time" [(ngModel)]="recurrenceObject.startTime" name="startTime" id="startTime"
						class="form-control">
				</div>
				<div class="col form-group mb-1" *ngIf="recurrenceObject.recurrence == '9' || recurrenceObject.recurrence == '10'">
					<label for="endTime" class="form-label">Hora Final</label>
					<input type="time" [(ngModel)]="recurrenceObject.endTime" name="endTime" id="endTime"
						class="form-control">
				</div>
				<div class="col form-group mb-1">
					<label for="name" class="form-label">Numero de Recibo</label>
					<input type="text" [(ngModel)]="recurrenceObject.receiptNumber" placeholder="Numero de recibo"
						name="name" id="name" class="form-control">
				</div>
			</div>
			<div class="row">
				<div class="col form-group mb-1" *ngIf="beginObject">
					<label for="recurrence" class="form-label">Recurrencia</label>
					<select name="recurrence" id="recurrence" (change)="resetTimes()"
						[(ngModel)]="recurrenceObject.recurrence" class="form-select">
						<option value="undefined">Elige una recurrencia</option>
						<ng-container *ngFor="let type of beginObject.recurrenceList">
							<option *ngIf="type.isActive" value="{{type.id}}">{{type.recurrence}}</option>
						</ng-container>
					</select>
				</div>
				<div class="col form-group mb-1">
					<label for="start-date" class="form-label">Fecha{{(recurrenceObject.recurrence != '9' && recurrenceObject.recurrence != '10' )?'
						Inicio':''}}</label>
					<input type="date" name="start-date" [(ngModel)]="recurrenceObject.startDate" id="start-date"
						class="form-control">
				</div>
				<div class="col form-group mb-1" *ngIf="recurrenceObject.recurrence != '9' && recurrenceObject.recurrence != '10'">
					<label for="end-date" class="form-label">Fecha Fin</label>
					<input type="date" name="end-date" [(ngModel)]="recurrenceObject.endDate" id="end-date"
						class="form-control">
				</div>
				<div class="col form-group mb-1">
					<label for="invoice-date" class="form-label">Fecha Factura</label>
					<input type="date" name="invoice-date" [(ngModel)]="recurrenceObject.billingDate" id="invoice-date"
						class="form-control">
				</div>
			</div>
			<!-- <div class="row mt-3" *ngIf="recurrenceObject.recurrence != '9'">
				<h3>2. Clientes</h3>
				<div class="form-group mb-1">
					<label for="client" class="form-label">Cliente</label>
					<span tooltip="Crea un cliente" class="clickeable text-info"><i
							class="fa fa-circle-plus"></i></span>
					<div class="input-group input-group-sm">
						<app-input-autocomplete [allBorderRadius]="false"
							[filterElements]="inputs.client.filterElements" [allBorderRadius]="true"
							[inputs]="inputs.client"
							(getTitle)="$event.filterElement.title = $event.filterElement.nit+ ' - ' + $event.filterElement.name"
							[placeholder]="'Ingresa un cliente'" (inputMethod)="writeClient($event.event.target.value)"
							(changeStatus)="selectClient($event.filterElement)">
						</app-input-autocomplete>
					</div>
				</div>
				<div class="table-responsive table-custom">
					<table class="table table-striped">
						<thead>
							<tr>
								<th scope="col">
									Cliente
								</th>
								<th scope="col" class="td-center limit-td">
									Email
								</th>
								<th scope="col" class="td-center limit-td limit-td-100">
									Cantidad de facturas
								</th>
								<th scope="col">
								</th>
							</tr>
						</thead>
						<tbody class="table-group-divider">
							<tr *ngFor="let client of recurrenceObject.clients; let i = index">
								<td>{{client.name}}</td>
								<td class="limit-td">
									<input type="text" class="form-control" name="contactMail" id="contactMail"
										[(ngModel)]="client.contactMail" placeholder="Configurar correo para factura">
								</td>
								<td class="limit-td limit-td-100"><input type="number" class="form-control"
										name="numberInvoices" id="numberInvoices" [(ngModel)]="client.numberInvoices"
										(input)="changeTotalFact($event)" placeholder="0"></td>
								<td class="td-center">
									<span class="clickeable text-danger" (click)="deleteClient(i)">
										<i class="fa fa-trash"></i>
									</span>
								</td>
							</tr>
							<tr *ngIf="recurrenceObject.clients.length == 0">
								<td colspan="4" class="text-muted td-center"><i class="fa fa-circle-info"></i>Aún no has
									ingresado clientes</td>
							</tr>
						</tbody>
						<tfoot>
							<tr>
								<td colspan="2" class="td-center">Total de facturas</td>
								<td class="td-center">{{recurrenceObject.totalFacts}}</td>
								<td></td>
							</tr>
						</tfoot>
					</table>
				</div>
			</div> -->
			<!-- <div class="row mt-3" *ngIf="recurrenceObject.recurrence == '9'">
				<h3>2. Clientes</h3>
				<div class="row">
					<div class="col form-group">
						<label for="clientType" class="form-label">Tipo de cliente</label>
						<div class="input-group">
							<button (click)="recurrenceObject.typeClient = !recurrenceObject.typeClient"
								[ngClass]="recurrenceObject.typeClient?'btn-primary':'btn-secondary'" class="btn">
								<i [ngClass]="recurrenceObject.typeClient?'fa-toggle-on':'fa-toggle-off'"
									class="fa"></i>
							</button>
							<input type="text" style="user-select: none;" disabled name="clientType" id="clientType"
								[value]="recurrenceObject.typeClient?'Personas Individuales':'Todos'"
								class="form-control">
						</div>
					</div>
					<div class="col form-group">
						<label for="department" class="form-label">Departamento</label>
						<select name="department" id="department" [(ngModel)]="tempLocation.department"
							(change)="setTowns()" class="form-select">
							<option value="undefined">Elige un departamento</option>
							<option *ngFor="let department of departments" value="{{department.id}}">{{department.name}}
							</option>
						</select>
					</div>
					<div class="col form-group">
						<label for="town" class="form-label">Municipio</label>
						<select name="town" [disabled]="!tempLocation.department" id="town"
							[(ngModel)]="tempLocation.town" (change)="selectTown($event)" class="form-select">
							<ng-container *ngIf="tempLocation.department">
								<option value="undefined">Elige un municipio</option>
								<option *ngFor="let town of towns" value="{{town.id}}">{{town.name}}
								</option>
							</ng-container>
							<ng-container *ngIf="!tempLocation.department">
								<option value="undefined">Selecciona departamento</option>
							</ng-container>
						</select>
					</div>
					<div class="col form-group">
						<label for="percentage" class="form-label">Porcentaje de facturas con C/F</label>
						<div class="input-group">
							<button tooltip="Activa si deseas facturas" (click)="activeCF()"
								[ngClass]="tempFact.wantCF?'btn-primary':'btn-secondary'" class="btn">
								<i [ngClass]="tempFact.wantCF?'fa-toggle-on':'fa-toggle-off'" class="fa"></i>
							</button>
							<input [disabled]="!tempFact.wantCF" type="number" class="form-control"
								placeholder="Activa para editar" [(ngModel)]="tempFact.percentage"
								(change)="formatPercentage()" max="100" min="0" id="percentage" name="percentage">
						</div>
					</div>
				</div>
				<div class="table-responsive table-custom" style="margin-top: 1em;">
					<table class="table table-striped">
						<thead>
							<tr>
								<th scope="col" class="td-center">
									Departamento
								</th>
								<th scope="col" class="td-center">
									Municipio
								</th>
								<th scope="col">
								</th>
							</tr>
						</thead>
						<tbody class="table-group-divider">
							<tr *ngFor="let location of locations; let i = index">
								<td class="td-center">
									{{departmentName[location.department]}}
								</td>
								<td class="td-center">
									{{townName[location.department+"#"+location.town]}}
								</td>
								<td class="td-center">
									<span class="clickeable text-danger" (click)="deleteLocation(i)">
										<i class="fa fa-trash"></i>
									</span>
								</td>
							</tr>
							<tr *ngIf="locations.length == 0">
								<td colspan="4" class="text-muted td-center"><i class="fa fa-circle-info"></i>Aún no has
									ingresado ubicaciones</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div> -->
			<div class="row mt-3">
				<h3>
					2. Detalle de factura
				</h3>
				<div class="row" *ngIf="recurrenceObject.recurrence == '9' || recurrenceObject.recurrence == '10'">
					<div class="col form-group">
						<label for="isPartial" class="form-label">Cantidad Parcial</label>
						<div class="input-group">
							<button (click)="recurrenceObject.isPartial= !recurrenceObject.isPartial"
								[ngClass]="recurrenceObject.isPartial?'btn-primary':'btn-secondary'" class="btn">
								<i [ngClass]="recurrenceObject.isPartial?'fa-toggle-on':'fa-toggle-off'" class="fa"></i>
							</button>
							<input type="text" style="user-select: none;" disabled name="isPartial" id="isPartial"
								[value]="recurrenceObject.isPartial?'ACEPTAR':'NEGAR'" class="form-control">
						</div>
					</div>
					<div class="col form-group">
						<label for="isPartial" class="form-label">Productos Unificados</label>
						<div class="input-group">
							<button (click)="tempUnifiedProducts= !tempUnifiedProducts"
								[ngClass]="tempUnifiedProducts?'btn-primary':'btn-secondary'" class="btn">
								<i [ngClass]="tempUnifiedProducts?'fa-toggle-on':'fa-toggle-off'" class="fa"></i>
							</button>
							<input type="text" style="user-select: none;" disabled name="isPartial" id="isPartial"
								[value]="tempUnifiedProducts?'UNIFICADOS':'SEPARADOS'" class="form-control">
						</div>
					</div>
					<div class="col form-group">
						<label for="isCashier" class="form-label">Forma de Pago</label>
						<div class="input-group">
							<button
								[tooltip]="recurrenceObject.isCashier?'Cambiar a Cuentas por Cobrar':'Cambiar a Caja'"
								(click)="recurrenceObject.isCashier= !recurrenceObject.isCashier"
								[ngClass]="recurrenceObject.isCashier?'btn-primary':'btn-secondary'" class="btn">
								<i [ngClass]="recurrenceObject.isCashier?'fa-toggle-on':'fa-toggle-off'" class="fa"></i>
							</button>
							<input *ngIf="!recurrenceObject.isCashier" type="text" name="isCashier" id="isCashier"
								class="form-control" disabled value="CUENTAS POR COBRAR">
							<label *ngIf="recurrenceObject.isCashier" for="isCashier"
								class="input-group-text">CAJA</label>
							<app-input-autocomplete *ngIf="recurrenceObject.isCashier" [allBorderRadius]="false"
								[filterElements]="inputs.cashier.filterElements" [typeElements]="'cashier'"
								[inputs]="inputs.cashier"
								(getTitle)="$event.filterElement.title = $event.filterElement.name"
								[placeholder]="'Ingresa una caja'"
								(inputMethod)="writeCashier($event.event.target.value)"
								(changeStatus)="selectCashier($event.filterElement)">
							</app-input-autocomplete>
						</div>
					</div>

					<div class="col form-group">
						<label for="isLimitPrice" class="form-label">Limite de Precio de Factura</label>
						<div class="input-group">
							<button
								[tooltip]="isLimitInvoicePrice ? 'Cambiar a Limite de precio' : 'Cambiar a Sin limite de Precio'"
								(click)="isLimitInvoicePrice = !isLimitInvoicePrice"
								[ngClass]="isLimitInvoicePrice ? 'btn-primary' : 'btn-secondary'" class="btn">
								<i [ngClass]="isLimitInvoicePrice ? 'fa-toggle-on' : 'fa-toggle-off'" class="fa"></i>
							</button>
					
							<input *ngIf="!isLimitInvoicePrice" type="text" name="isLimitPrice" id="isLimitPrice"
								class="form-control" disabled value="SIN LIMITE DE PRECIO">
					
							<label *ngIf="isLimitInvoicePrice" for="isLimitPrice"
								class="input-group-text">PRECIO</label>
					
							<input *ngIf="isLimitInvoicePrice" type="number" class="form-control number-input"
								[placeholder]="'Ingresa un monto'"
								[min]="0"
								[(ngModel)]="limitInvoicePrice"
								(input)="validatePositiveNumber($event)">
						</div>
					</div>
							
				</div>
				<div class="form-group">
					<label for="bank">Banco:</label>
					<select name="bank" id="bank" class="form-select" [(ngModel)]="recurrenceObject.idBank" (change)="onBankChange($event)">
					  <option [ngValue]="undefined">Seleccione un banco</option>
					  <option *ngFor="let bank of banks" [ngValue]="bank.id">
						{{bank.accountNumber}} - {{bank.alias}}
					  </option>
					</select>
				  </div>
				<div class="form-group" id="product-div">
					<label for="producto" class="form-label">Producto/Servicio</label>
					<div class="input-group">
						<app-input-autocomplete [allBorderRadius]="true"
							[filterElements]="inputs.product.filterElements" [typeElements]="'product'"
							[inputs]="inputs.product" [ruleToDisabled]="!recurrenceObject.wareHouse"
							(getTitle)="setProductTitle($event.filterElement)"
							[placeholder]="(recurrenceObject.wareHouse)?'Ingresa un producto':'Selecciona una bodega primero'"
							(inputMethod)="writeProduct($event.event.target.value)"
							(changeStatus)="selectProduct($event.filterElement)">
						</app-input-autocomplete>
					</div>
				</div>
				<div class="input-group input-group-sm mb-1" *ngIf="tempProduct">
					<label for="mount" class="input-group-text">Cantidad</label>
					<input type="number" [(ngModel)]="tempProduct.quantity" value="1" class="form-control" name="mount"
						id="mount">
					<label for="price" class="input-group-text">Precio</label>
					<input type="number" [(ngModel)]="tempProduct.price" value="0" class="form-control" name="price"
						id="price">
					<ng-container *ngIf="tempProduct?.type == 'b'">
						<label for="stock" class="input-group-text" 
								[ngClass]="{
								'text-success fw-bold': tempProduct.existence > 0,
								'text-danger fw-bold': tempProduct.existence <= 0
								}">Existencias</label>
						<input type="number"
								[(ngModel)]="tempProduct['existence']"
								class="form-control"
								name="stock"
								id="stock"
								disabled *ngIf="recurrenceObject.recurrence == '10'">
					</ng-container>
					<ng-container *ngIf="tempProduct?.type == 'b' && recurrenceObject.recurrence == '10'" >
						<label for="stock" class="input-group-text">Costo</label>
						<input type="number"
								[(ngModel)]="tempProduct['costProd']"
								class="form-control"
								name="costProd"
								id="costProd"
								disabled *ngIf="recurrenceObject.recurrence == '10'">
					</ng-container>
					<label for="total" class="input-group-text">Total</label>
					<input type="text" value="{{tempProduct.quantity*tempProduct.price | currency: 'Q'}}"
						class="form-control" name="total" id="total" disabled>
					<button class="btn btn-primary" type="button"
							id="add-product"
							[disabled]="!tempProduct.quantity || !tempProduct.price || (tempProduct.type === 'b' && tempProduct['existence'] != null && tempProduct.quantity > tempProduct['existence'])"
							(click)="addProduct()">
					Agregar <i class="fa fa-cart-plus"></i>
					</button>
				</div>
				<div id="miDiv" class="table-container table-responsive" style="margin-top: 1em;">
					<table class="table table-striped" id="table-height">
						<thead>
							<tr>
								<th scope="col">#</th>
								<th scope="col">Producto</th>
								<th scope="col" class="td-center limit-td limit-td-100">Cantidad</th>
								<th scope="col" class="td-center limit-td limit-td-100">Precio Unidad</th>
								<th *ngIf="recurrenceObject.recurrence == '9' || recurrenceObject.recurrence == '10'" scope="col"
									class="td-center limit-td limit-td-100">Unidades por factura</th>
								<th scope="col" class="td-center">Total</th>
								<th scope="col"></th>
							</tr>
						</thead>
						<tbody class="table-group-divider">
							<tr *ngFor="let product of listProducts; let i = index" class="row-product"
								id="p{{product.code}}">
								<td scope="row">{{i+1}}</td>
								<td>
									<span *ngIf="!edited[product.id]" (click)="edited[product.id] = true"
										class="toggle-icon">{{product.name}}<i class="fa fa-edit"></i></span>
									<input *ngIf="edited[product.id]" class="form-control" type="text"
										name="description" id="description" [(ngModel)]="product.productDescription">
								</td>
								<td class="limit-td limit-td-100"><input class="form-control" id="m{{product.quantity}}"
										type="number" (input)="sumQuantities()" [(ngModel)]="product.quantity">
								</td>
								<td class="limit-td limit-td-100"><input class="form-control" id="pr{{product.price}}"
										type="number" (input)="product.priceEdited = true; sumQuantities()" [(ngModel)]="product.price">
								</td>
								<td *ngIf="recurrenceObject.recurrence == '9' || recurrenceObject.recurrence == '10'" class="limit-td limit-td-100">
									<input class="form-control" id="units{{i}}" type="number"
										[(ngModel)]="product['units']">
								</td>
								<td class="td-center">{{product.quantity*product.price | currency: 'Q'}}</td>
								<td class="td-center">
									<span class="clickeable text-danger" (click)="deleteProduct(i)">
										<i class="fa fa-trash"></i>
									</span>
								</td>
							</tr>
							<tr *ngIf="listProducts.length == 0">
								<td [colSpan]="(recurrenceObject.recurrence=='9' || recurrenceObject.recurrence == '10')?7:6" class="text-muted td-center"><i
										class="fa fa-circle-info"></i>Aún no has
									ingresado productos</td>
							</tr>
						</tbody>
						<tfoot>
							<tr>
								<td class="td-center" [colSpan]="(recurrenceObject.recurrence=='9' || recurrenceObject.recurrence == '10')?5:4">Total</td>
								<td class="td-center">{{totalToPay | currency: 'Q'}}</td>
								<td></td>
							</tr>
						</tfoot>
					</table>
				</div>
			</div>
		</div>
	</div>
</div>